import { ICrmSurveyResponseVm } from "../models/response/crm-survey/ICrmSurveyResponse";
import { apiClient } from "./apiClient";
import { apiGuestClient } from "./apiGuestClient";

export const crmSurveyResponseApi = {
    selectAll: () => apiClient.get(`crm_survey-respone`),
    selectDetail: (id: number) => apiGuestClient.get(`crm_survey-respone/${id}`),
    saveChanges: (data: ICrmSurveyResponseVm) => apiGuestClient.post(`crm_survey-respone`, data),
    updateStatus: (id: number, status: number) => apiClient.put(`crm_survey-respone/${id}/status/${status}`),
    getHocSinhByResponseId: (id: number) => apiClient.get(`crm_survey-respone/${id}/hocsinh`),
    getHocSinhMappings: () => apiClient.get(`crm_survey-respone/hocsinh-mappings`),
    getFormQuestionMappings: (formId: number) => apiClient.get(`crm_survey-respone/form/${formId}/hocsinh-mappings`),
    delete: (id: number) => apiClient.delete(`crm_survey-respone/${id}`),
}